export default __webpack_public_path__ + "static/media/learning-device.1f5be179.png";